import { Show, SignInButton } from '@clerk/react'
import { Menu, ShoppingCart, X } from 'lucide-react'
import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useCart } from '../lib/cart'
import { UserMenu } from './UserMenu'

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false)
  const location = useLocation()
  const { count, openCart } = useCart()
  const homePrefix = location.pathname === '/' ? '' : '/'

  const closeMenu = () => setMenuOpen(false)

  return (
    <header className="site-header">
      <Link className="brand" to="/" onClick={closeMenu} aria-label="CheatsEclipse, home">
        <span className="brand__mark">
          <img src="/logo.webp" alt="" />
        </span>
        <span className="brand__name">CheatsEclipse</span>
      </Link>

      <button
        className="nav-toggle icon-button"
        type="button"
        onClick={() => setMenuOpen((value) => !value)}
        aria-expanded={menuOpen}
        aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
      >
        {menuOpen ? <X size={19} /> : <Menu size={19} />}
      </button>

      <nav className="main-nav" data-open={menuOpen ? 'true' : 'false'} aria-label="Main navigation">
        <a href={`${homePrefix}#products`} onClick={closeMenu}>Products</a>
        <a href={`${homePrefix}#experience`} onClick={closeMenu}>Experience</a>
        <Link to="/account" onClick={closeMenu}>My account</Link>
      </nav>

      <div className="header-actions">
        <button
          className="header-bag cart-button"
          type="button"
          onClick={openCart}
          aria-label={count > 0 ? `Open cart, ${count} ${count === 1 ? 'item' : 'items'}` : 'Open cart'}
        >
          <ShoppingCart size={17} />
          {count > 0 ? <span className="cart-button__badge">{count}</span> : null}
        </button>
        <Show when="signed-out">
          <SignInButton mode="modal">
            <button className="button button--ghost button--small" type="button">Sign in</button>
          </SignInButton>
        </Show>
        <Show when="signed-in">
          <UserMenu />
        </Show>
      </div>
    </header>
  )
}
